//============================================================================
// Name        : inventory.ts
// Purpose     : Implement inventory dynamic logic
// Created     : 2020-02-12
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import moment from "moment";
import * as QueryString from "querystring";
import {InitPage} from "../index";

declare var inventoryLocationUrl: string;
declare var locations: string;
declare var multiSearchUrl: string;
declare var sortableLocations;

interface IItem {
    epc_id: string;
    item_number: string;
    category_name: string;
    size: string;
    description: string;
    colour: string;
    style: string;
    item_type: string;
    zone: string;
    status: string;
}

interface IInventoryResponse {
    total_count: number;
    results: IItem[];
}

class Inventory {
    refreshLocation = null;
    httpRequest = null;

    init() {
        $("select").not("#itemscount").select2({
            minimumResultsForSearch: 5
        });
        $("#itemscount").select2({
            minimumResultsForSearch: Infinity
        });

        $("#itemscount").on("change", () => {
            const url = window.location.href;
            window.location.href = this.updateParameter(url, "per_page", $("#itemscount").val());
        });

        // When opening the export to CSV dialog autofocus the email field
        $("#showExportCSV").on("click", () => {
            setTimeout(() => $("#email").focus(), 1000);
        });

        this.initLiveTracking();
        if (typeof multiSearchUrl != "undefined") {
            this.multiSearch();
        }
    }

    initLiveTracking() {
        const liveStreamingCheck = $("#livestreaming");

        liveStreamingCheck.prop("checked", false);
        liveStreamingCheck.on("change", () => {
            if ($(this).prop("checked") == true) {
                this.refreshLocation = setInterval(this.updateAssetLocation, 3000);
            }
            else {
                clearInterval(this.refreshLocation);
                this.refreshLocation = 0;
                if(this.httpRequest) {
                    this.httpRequest.abort();
                }
            }
        });
    }

    updateAssetLocation() {
        let sortZoneName = "";

        if (window.location.search) {
            const sortName = decodeURIComponent(this.urlParam("zone_filter%5B%5D") as string);
            sortZoneName = sortName.replace(/\+/g, " ");
        }

        const perPageItem = $("#itemscount").val();
        this.httpRequest = $.ajax({
            type: "GET",
            url:  inventoryLocationUrl,
            data: {
                per_page:  perPageItem,
                zone_name: sortZoneName
            },
            success: (data: IInventoryResponse) => {
                let content = "";
                const count = data.total_count;

                for (const item of data.results) {
                    content += `
                    <tr id="${item.epc_id}">
                        <td>${item.item_number}</td>
                        <td>${item.category_name}</td>
                        <td>${item.size}</td>
                        <td>${item.description}</td>
                        <td>${item.colour}</td>
                        <td>${item.style}</td>
                        <td>${item.item_type}</td>
                        <td>${item.zone}</td>
                        <td>${moment(item["}last_seen"]).format("MM/DD/YYYY hh:mm a")}</td>
                        <td>${item.status}</td>
                        <td>
                            <a data-toggle="modal" data-id="${item.epc_id}" data-slno=""
                                title="Add this item" class="open-showEpc" href="#showEPc">
                                <i class="fa fa-tags fa-2x"></i>
                            </a>
                        </td>
                        <td>
                            <div class="text-center">
                                <div class="checkbox">
                                    <input type="checkbox" name="handheld[]" value="">
                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                    <span></span>
                                </div>
                            </div>
                        </td>
                    </tr>`;
                }

                $("#inventoryTable tbody").html(content);
                $("#inventoryCount").html(count.toString);
            }
        });
    }

    urlParam(name: string) {
        const results = new RegExp("[\?&]" + name + "=([^&#]*)").exec(window.location.href);
        return results[1] || 0;
    }

    updateParameter(uri, key, value) {
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf("?") != -1 ? "&" : "?";

        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
            return uri + separator + key + "=" + value;
        }
    }

    multiSearch() {
        let count = 0;
        $("#loading-tag").show();
        const filters = this.filtersAsObject();
        $.each(sortableLocations, (index, value) => {
            const requestData = {
                search:        $("#search").val(),
                tenant_code:   value.name,
                inventory_log: $("#inventory_log").val()
            };
            count = count + 1;
            $.ajax({
                url: multiSearchUrl,
                data: {...requestData, ...filters, 'sort':value.sort, 'direction': value.direction, 'tenant_code': value.name},
                method: "POST",
                success: (data) => {
                    $("#parent-table").append(data);
                    // count = count + 1;

                    if (count >= locations.length) {
                        $("#loading-tag").hide();
                    }
                }
            });
        });
    }

    filtersAsObject(): object {
        const params = QueryString.parse(location.search);

        // Remove general params from the query
        delete params["?utf8"];
        if (Object.keys(params).includes("search")) {
            delete params.search;
        }
        if (Object.keys(params).includes("multilocation")) {
            delete params.multilocation;
        }
        if (Object.keys(params).includes("commit")) {
            delete params.commit;
        }
        if (Object.keys(params).includes("per_page")) {
            delete params.per_page;
        }
        return params;
    }
}

export function LoadPage() {
    InitPage("epc_tags inventory_logs", () => {
        const inventory = new Inventory();
        inventory.init();
    });
}
